import {
  FeatureFlagKey,
  type FeatureFlags,
} from "../utils/resolveFlags/featureFlags.type";

export const defaultFeatureFlags: FeatureFlags = Object.freeze({
  // WIZARDS
  [FeatureFlagKey.WIZARDS]: {
    enabled: true,
    disabledTenants: [],
  },
  [FeatureFlagKey.FIRE_PROTECTION_WIZARD]: {
    enabled: true,
    disabledTenants: [],
    parent: FeatureFlagKey.WIZARDS,
  },
  [FeatureFlagKey.ROOM_CONTROL_WIRED_WIZARD]: {
    enabled: true,
    disabledTenants: [],
    parent: FeatureFlagKey.WIZARDS,
  },
  [FeatureFlagKey.ROOM_CONTROL_WIRELESS_WIZARD]: {
    enabled: true,
    disabledTenants: [],
    parent: FeatureFlagKey.WIZARDS,
  },
  [FeatureFlagKey.X_CUBE_WIZARD]: {
    enabled: true,
    disabledTenants: [],
    parent: FeatureFlagKey.WIZARDS,
  },
  [FeatureFlagKey.X_FANS_WIZARD]: {
    enabled: true,
    disabledTenants: [],
    parent: FeatureFlagKey.WIZARDS,
  },
  // _____________________________________________________________________________
  // PRODUCT CONFIGURATOR
  [FeatureFlagKey.PRODUCTS]: {
    enabled: true,
    disabledTenants: [],
  },
  [FeatureFlagKey.RESULTING_LIST]: {
    enabled: true,
    disabledTenants: [],
    parent: FeatureFlagKey.PRODUCTS,
  },
  // _____________________________________________________________________________
  // PROJECTS
  [FeatureFlagKey.PROJECTS]: {
    enabled: true,
    disabledTenants: [],
  },
  // _____________________________________________________________________________
  // LIBRARY
  [FeatureFlagKey.LIBRARY]: {
    enabled: true,
    disabledTenants: [],
  },
});
